import { render, staticRenderFns } from "./InsuranceTypeTable.vue?vue&type=template&id=1380117e&"
import script from "./InsuranceTypeTable.vue?vue&type=script&lang=js&"
export * from "./InsuranceTypeTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports